<section class="pt-60 pb-60 secondary-header-container" *ngIf="width == 'FULL'">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center text-white" [innerHTML]="title">
            </div>
        </div>
    </div>
</section>

<div class="container pt-60 pb-60 secondary-header-container" *ngIf="width == 'CONSTRAINED'">
    <div class="row">
        <div class="col-12 text-center text-white" [innerHTML]="title">
        </div>
    </div>
</div>